import React, { ReactNode } from 'react';

// Utils
import { client } from '../../../tina/__generated__/client';

// Types
import { CoBrandDataModel } from '@brz-types/cobrand.data.model';
import { useReferralParams } from './referral.helper';
import { usePage } from './page.context';



type CoBrandContextModel = {
    coBrand: CoBrandDataModel | null;
    setCoBrand: React.Dispatch<React.SetStateAction<CoBrandDataModel | null>>;
};

const CoBrandingContext = React.createContext({} as CoBrandContextModel);


export const CoBrandingContextWrapper = ({ children }: { children: ReactNode | ReactNode[] }) => {
    const { page: settings } = usePage();

    const [coBrand, setCoBrand] = React.useState<CoBrandDataModel | null>(settings.partner?.cobrandRef || null);

    return (
        <CoBrandingContext.Provider value={{
            coBrand,
            setCoBrand,
        }}>
            { children }
        </CoBrandingContext.Provider>
    )
};

export const useCoBranding = () => React.useContext(CoBrandingContext);